import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';

export function NewsletterFormSuccess() {
  return (
    <Fragment>
      <p className="mb4 f6 f7-lg">Thanks for subscribing!</p>
      <p className="mb7">
        <span>We&apos;ll be in touch soon.  In the meantime, be sure to check out our</span>
        &nbsp;
        <a
          className="underline"
          href="https://www.instagram.com/gooddog"
          rel="noopener noreferrer"
          target="_blank"
        >
          #GoodDogPack on Instagram
        </a>!
      </p>
    </Fragment>
  );
}

export default class NewsletterForm extends Component {
  static propTypes = {
    className: PropTypes.string,
    formState: PropTypes.shape({
      email: PropTypes.string
    }).isRequired,
    handleFormFieldChange: PropTypes.func.isRequired,
    handleFormSubmission: PropTypes.func.isRequired,
    didFormSubmissionSucceed: PropTypes.bool.isRequired
  };

  static defaultProps = {
    className: null
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.handleFormSubmission();
  };

  render() {
    const {
      className,
      formState,
      handleFormFieldChange,
      didFormSubmissionSucceed
    } = this.props;

    return (
      <div className={ classnames('NewsletterForm pv14 bg-purple white tc', className) }>
        <div className="container">
          <div className="NewsletterForm__contents center">
            { didFormSubmissionSucceed ? (
              <NewsletterFormSuccess />
            ) : (
              <form onSubmit={ this.handleSubmit }>
                <p className="mb4 f6">(In)box full of puppies?</p>
                <p className="mb7 fw-medium">Get cute pups, helpful tips, and more sent to your inbox.</p>
                <div className="NewsletterForm__input w-90-lg relative center">
                  <input
                    className="w-100 pv3 pl4 pr10 bw0 input-reset br1 black"
                    name="email"
                    onChange={ handleFormFieldChange }
                    placeholder="Enter your email address"
                    type="email"
                    value={ formState.email || '' }
                  />
                  <button type="submit" className="mr3 right-0 purple f5 transform-center">
                    <Icon name="lined-arrow-right" />
                  </button>
                </div>
              </form>
            ) }
          </div>
        </div>
      </div>
    );
  }
}
